<template>
    <div class="TxAddToCartPortal" v-if="$root.env === 'frontend'">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "TxAddToCartPortal",
        mounted() {
            if (this.$root.env === 'frontend') {
                document.body.querySelector('.woocommerce-variation-add-to-cart').appendChild(this.$el);
            }
        },
    }
</script>

<style scoped>

</style>